import { baseElementSchema } from "@/Components/Exercises/Elements/base";
import { z } from "zod";

export const explanationElementSchema = baseElementSchema.extend({
    type: z.literal("explanation"),
});
export const explanationElementDataSchema = z.object({});
export type ExplanationElement = z.infer<typeof explanationElementSchema>;
export type ExplanationElementData = z.infer<
    typeof explanationElementDataSchema
>;
